import './RightTop.css';

export const RightTop = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="right-top">
      {children}
    </div>
  )
}
